module.exports = __webpack_public_path__ + "img/layers_icon_251258-1.467a2be3.png";